import React, { useContext, useMemo, useState, useEffect, useRef } from "react";
import VehiclePagecard2 from "../../components/Cards/VehiclePagecard2";
import BarChart from "../../components/Graphs/BarGraph/sparesbar";
import { Sparesline } from "../../components/Graphs/LineGraph/sparesline";
import StatewiseTable from "../../components/Table/Statewisetable";
import Vehiclespares from "../../components/Table/Vehiclespares";
import MonthTable from "../../components/Table/Monthwisecomplaint";
import Header from "../../components/Header/Header";
import Sparescard from "../../components/Cards/Sparescard";
import Group from "../../assets/images/Group.svg";
import framevehicle from "../../assets/images/Framevehicle.svg";
import StateMap from "../../components/Maps/Statewisemap";
import { TbFilterDown } from "react-icons/tb";
import { IoMdArrowForward } from "react-icons/io";
import Tabledetails from "../../components/Table/Tabledetails";
import Filter from "../../components/Filter/Filtercomplaint";
import { FilterContext } from "../../context/Filter";
import {
  divisionWiseTableData,
  getSalesComplaint,
  lobPplPlTableData,
  monthWiseGraphData,
  problemAreaTableData,
  problemAreaWiseTableData,
  stateGraphData,
  totalComplaints,
  totalComplaintsAvgTat,
  getOpenSalesComplaints,
  getReopenedSalesComplaints,
  primaryAreaWiseComplaintsData,
  getSalesComplaintTATMonth,
} from "../Complaints/complaintsFilterKpi";
import JCcardtable from "../../components/Cards/Jccardtable";
import Psfaccordian from "../../components/ChildData/Psfaccordian";
import NavButtons from "../../components/NevBar/NavButtons";
import SalesComplaintTat from "../../components/Graph/Barchart/SalesComplaintTat";
import CustomerMetricsAccordian from "../../components/psfSalesService/CustomerMetricsAccordian";
import WaterMark from "../../components/WaterMark";

const Complaintindex = () => {
  const {
    arn: parArn,
    childArn,
    complaintsPayload,
    setComplaintsPayload,
    isFilterReady,
  } = useContext(FilterContext);

  const shouldEnableQuery = Boolean(parArn || childArn);

  const [loading, setLoading] = useState(true);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [totalComplaintsValue, setTotalComplaintsValue] = useState(null);
  const [closedComplaintsValue, setClosedComplaintsValue] = useState(null);
  const [openComplaintsValue, setOpenComplaintsValue] = useState(null);

  const [totalAvgTat, setTotalAvgTat] = useState(null);
  const [closeAvgTat, setCloseAvgTat] = useState(null);
  const [openAvgTat, setOpenAvgTat] = useState(null);

  const [stateGraphValue, setStateGraphValue] = useState(null);
  const [monthWiseGraphValues, setMonthWiseGraphValues] = useState(null);
  const [problemAreawiseGraph, setProblemAreawiseGraph] = useState(null);
  const [divisionWiseTableValues, setDivisionWiseTableValues] = useState(null);
  const [problemAreaTableValues, setProblemAreaTableValues] = useState(null);
  const [lobPplPlTableValues, setLobPplPlValues] = useState(null);

  const [salesComplaintTat, setSalesComplaintTat] = useState(null);
  const [salesComplaintTatMonth, setSalesComplaintTatMonth] = useState(null);
  const [openSalesComplaint, setOpenSalesComplaint] = useState(null);
  const [reOpenedSalesComplaint, setReopenedSalesComplaint] = useState(null);

  const [shouldRender, setShouldRender] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [primaryAreaWiseComplaints, setPrimaryAreaWiseComplaint] =
    useState(null);

  const [showProblemArea, setShowProblemArea] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);

  const isValidData = (data) =>
    data !== null &&
    typeof data === "object" &&
    Object.keys(data).length > 0;

  const handleFilterChange = () => {
    setIsFilterOpen((prev) => !prev);
  };

  // Check if year is selected in complaintsPayload
  const isYearSelected = useMemo(() => {
    return (
      complaintsPayload?.years !== undefined &&
      complaintsPayload?.years !== null &&
      complaintsPayload?.years !== ""
    );
  }, [complaintsPayload]);

  /*
   * Helper for Promise.allSettled()
   *
   * Promise.allSettled() returns:
   *
   * {
   *   status: "fulfilled",
   *   value: actualApiResponse
   * }
   *
   * OR
   *
   * {
   *   status: "rejected",
   *   reason: error
   * }
   *
   * This helper returns the actual value when API succeeds
   * and the fallback value when API fails.
   */
  const getSettledValue = (result, fallback) => {
    if (result.status === "fulfilled") {
      return result.value;
    }

    console.error("API failed:", result.reason);
    return fallback;
  };

  /*
   * Safely format Average TAT.
   *
   * Handles:
   *   12.45
   *   "12.45"
   *   null
   *   undefined
   *   invalid values
   */
  const formatTat = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "N/A";
    }

    const numericValue = Number(value);

    if (Number.isNaN(numericValue)) {
      return "N/A";
    }

    return numericValue.toFixed(2);
  };

  const refetchAllVehicleData = async () => {
    if (!shouldEnableQuery) return;

    setLoading(true);

    try {
      const closedPayload = {
        ...complaintsPayload,
        status: "Closed",
      };

      const openPayload = {
        ...complaintsPayload,
        status: "Open",
      };

      /*
       * IMPORTANT:
       *
       * Promise.allSettled() allows all APIs to execute independently.
       *
       * If one API fails, the other APIs will still return their
       * successful responses.
       */
      const [
        totalComplaintsResp,
        closedComplaintsResp,
        openComplaintsResp,
        totalAvgTatResp,
        ClosedAvgTatResp,
        OpenAvgTatResp,
        stateGraphResp,
        monthwiseGraphResp,
        problemAreaWiseGraphResp,
        divisionWiseTableResp,
        problemAreaTableResp,
        lobPplPlTableResp,
        salesComplaintTatResp,
        salesComplaintTatMothResp,
        openSalesComplaintResp,
        reOpenedSalesComplaintResp,
        primaryAreaWiseComplaintsResp,
      ] = await Promise.allSettled([
        totalComplaints(
          parArn,
          childArn,
          complaintsPayload
        ),

        totalComplaints(
          parArn,
          childArn,
          closedPayload
        ),

        totalComplaints(
          parArn,
          childArn,
          openPayload
        ),

        totalComplaintsAvgTat(
          parArn,
          childArn,
          complaintsPayload
        ),

        totalComplaintsAvgTat(
          parArn,
          childArn,
          closedPayload
        ),

        totalComplaintsAvgTat(
          parArn,
          childArn,
          openPayload
        ),

        stateGraphData(
          parArn,
          childArn,
          complaintsPayload
        ),

        monthWiseGraphData(
          parArn,
          childArn,
          complaintsPayload
        ),

        problemAreaWiseTableData(
          parArn,
          childArn,
          complaintsPayload
        ),

        divisionWiseTableData(
          parArn,
          childArn,
          complaintsPayload
        ),

        problemAreaTableData(
          parArn,
          childArn,
          complaintsPayload
        ),

        lobPplPlTableData(
          parArn,
          childArn,
          complaintsPayload
        ),

        getSalesComplaint(
          parArn,
          childArn,
          complaintsPayload
        ),

        getSalesComplaintTATMonth(
          parArn,
          childArn,
          complaintsPayload
        ),

        getOpenSalesComplaints(
          parArn,
          childArn,
          complaintsPayload
        ),

        getReopenedSalesComplaints(
          parArn,
          childArn,
          complaintsPayload
        ),

        primaryAreaWiseComplaintsData(
          parArn,
          childArn,
          complaintsPayload
        ),
      ]);

      /*
       * Extract actual values from Promise.allSettled()
       */

      setTotalComplaintsValue(
        getSettledValue(totalComplaintsResp, {})
      );

      setClosedComplaintsValue(
        getSettledValue(closedComplaintsResp, {})
      );

      setOpenComplaintsValue(
        getSettledValue(openComplaintsResp, {})
      );

      setTotalAvgTat(
        getSettledValue(totalAvgTatResp, null)
      );

      setCloseAvgTat(
        getSettledValue(ClosedAvgTatResp, null)
      );

      setOpenAvgTat(
        getSettledValue(OpenAvgTatResp, null)
      );

      setStateGraphValue(
        getSettledValue(stateGraphResp, {})
      );

      setMonthWiseGraphValues(
        getSettledValue(monthwiseGraphResp, {})
      );

      setProblemAreawiseGraph(
        getSettledValue(problemAreaWiseGraphResp, {})
      );

      setDivisionWiseTableValues(
        getSettledValue(divisionWiseTableResp, {})
      );

      setProblemAreaTableValues(
        getSettledValue(problemAreaTableResp, {})
      );

      setLobPplPlValues(
        getSettledValue(lobPplPlTableResp, {})
      );

      setSalesComplaintTat(
        getSettledValue(salesComplaintTatResp, [])
      );

      setSalesComplaintTatMonth(
        getSettledValue(salesComplaintTatMothResp, [])
      );

      setOpenSalesComplaint(
        getSettledValue(openSalesComplaintResp, {})
      );

      setReopenedSalesComplaint(
        getSettledValue(reOpenedSalesComplaintResp, {})
      );

      setPrimaryAreaWiseComplaint(
        getSettledValue(
          primaryAreaWiseComplaintsResp,
          {}
        )
      );

    } catch (error) {
      /*
       * This should only handle unexpected errors.
       *
       * Individual API failures are already handled by
       * Promise.allSettled().
       */
      console.error(
        "Unexpected error fetching complaint data:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Check if serviceType exists and equals "Sales"
    if (complaintsPayload?.serviceType === "Sales") {
      setShouldRender(true);
    } else {
      setShouldRender(false);
    }
  }, [complaintsPayload]);

  useEffect(() => {
    if (!isFilterReady) return;

    refetchAllVehicleData();
  }, [parArn, childArn, complaintsPayload]);

  if (!isFilterReady || loading) {
    return (
      <div className="flex justify-center items-center h-[80vh]">
        <div className="text-xl font-semibold">
          Loading complaint data...
        </div>
      </div>
    );
  }

  return (
    <div className="">
      {/* Header & Filter */}
      <WaterMark />

      <Header heading={"Complaints"} />

      <div className="mt-2 m-5">
        <CustomerMetricsAccordian />
      </div>

      <div className="top-0 left-0 w-full z-10 bg-white shadow-md">
        {isFilterOpen && <Filter />}
      </div>

      {/* Cards */}
      <div className="block md:flex justify-items-center justify-center text-gray-400">
        <div className="block md:flex gap-8 justify-items-center justify-center">

          {/* Total Complaints */}
          <Sparescard
            heading="Total Complaints"
            heading2="Average TAT"
            value={
              totalComplaintsValue?.doc_count ?? "N/A"
            }
            value2={formatTat(totalAvgTat)}
            logo={Group}
          />

          {/* Closed Complaints */}
          <Sparescard
            heading="Closed Complaints"
            heading2="Average TAT"
            value={
              closedComplaintsValue?.doc_count ?? "N/A"
            }
            value2={formatTat(closeAvgTat)}
            logo={framevehicle}
          />

          {/* Open Complaints */}
          <Sparescard
            heading="Open Complaints"
            heading2="Average TAT"
            value={
              openComplaintsValue?.doc_count ?? "N/A"
            }
            value2={formatTat(openAvgTat)}
            logo={framevehicle}
          />
        </div>

        <div
          className="bg-[#087FC3] rounded-md p-2 mt-6 ml-2 w-10 h-12 flex justify-center items-center cursor-pointer"
          onClick={handleFilterChange}
        >
          <TbFilterDown
            size={30}
            className="text-white"
          />
        </div>
      </div>

      <div className="block md:grid grid-cols-3 gap-1 justify-center m-1 justify-items-center relative">

        {/* Column 1 */}
        <VehiclePagecard2
          heading="State-Wise Distribution"
          des={
            isValidData(stateGraphValue) ? (
              <StateMap data={stateGraphValue} />
            ) : (
              <div className="h-64 flex justify-center items-center">
                No data
              </div>
            )
          }
        />

        {/* Column 2 */}
        <VehiclePagecard2
          heading="Month Wise Complaints"
          des={
            isValidData(monthWiseGraphValues) ? (
              <Sparesline
                complaintFiscalYearWiseStateData={
                  monthWiseGraphValues
                }
              />
            ) : (
              <div className="h-64 flex justify-center items-center">
                No data
              </div>
            )
          }
        />

        {/* Column 3 — Carousel for last two cards */}
        <div className="w-full">
          <div className="ml-3 md:ml-0 w-full">
            <VehiclePagecard2
              heading={
                <div className="flex justify-between items-center">

                  <h2 className="text-lg font-semibold">
                    {showProblemArea
                      ? "Problem Area Wise Complaints"
                      : "Primary Area Wise Complaints"}
                  </h2>

                  {/* Toggle switch with hover tooltip */}
                  <div
                    className="relative group"
                    onMouseEnter={() =>
                      setShowTooltip(true)
                    }
                    onMouseLeave={() =>
                      setShowTooltip(false)
                    }
                  >
                    <label
                      className={`
                        relative inline-flex items-center cursor-pointer rounded-full p-1 transition-all duration-200
                        ${
                          showProblemArea
                            ? "hover:bg-green-50"
                            : "hover:bg-blue-50"
                        }
                      `}
                    >
                      <input
                        type="checkbox"
                        checked={!showProblemArea}
                        onChange={() =>
                          setShowProblemArea(
                            (prev) => !prev
                          )
                        }
                        className="sr-only peer"
                      />

                      {/* Track */}
                      <div
                        className={`
                          w-10 h-5 rounded-full transition-colors duration-300
                          ${
                            showProblemArea
                              ? "bg-gray-300"
                              : "bg-[#087FC3]"
                          }
                        `}
                      ></div>

                      {/* Thumb */}
                      <div
                        className="absolute left-1 top-1.5 bg-white w-4 h-4 rounded-full shadow-sm transition-transform duration-300 peer-checked:translate-x-5"
                      ></div>
                    </label>

                    {/* Hover Tooltip */}
                    {showTooltip && (
                      <div className="absolute top-full right-0 mt-2 z-50 animate-fadeIn">
                        <div className="bg-gray-800 text-white text-xs font-medium px-3 py-2 rounded-md shadow-lg whitespace-nowrap">

                          {showProblemArea
                            ? "Primary Area Wise Complaints"
                            : "Problem Area Wise Complaints"}

                          <div className="absolute -top-1 right-4 w-2 h-2 bg-gray-800 transform rotate-45"></div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              }
              des={
                showProblemArea ? (
                  isValidData(
                    problemAreawiseGraph
                  ) ? (
                    <BarChart
                      data={problemAreawiseGraph}
                    />
                  ) : (
                    <div className="h-64 flex justify-center items-center text-gray-500">
                      No data
                    </div>
                  )
                ) : isValidData(
                    primaryAreaWiseComplaints
                  ) ? (
                  <BarChart
                    data={primaryAreaWiseComplaints}
                  />
                ) : (
                  <div className="h-64 flex justify-center items-center text-gray-500">
                    No data
                  </div>
                )
              }
            />
          </div>
        </div>
      </div>

      <div className="block md:grid grid-cols-3 gap-1 mt-2 m-1 justify-center justify-items-center md:gap-1">

        {/* Division Table */}
        <VehiclePagecard2
          heading="State-Wise Distribution"
          des={
            isValidData(
              divisionWiseTableValues
            ) ? (
              <StatewiseTable
                complaintsDivisionTableStateFilterData={
                  divisionWiseTableValues
                }
              />
            ) : (
              <div className="p-4 text-center text-gray-400">
                No data
              </div>
            )
          }
        />

        {/* Problem Area Table */}
        <VehiclePagecard2
          heading="Month Wise Complaints"
          des={
            isValidData(
              problemAreaTableValues
            ) ? (
              <MonthTable
                complaintsPaTableStateFilterData={
                  problemAreaTableValues
                }
              />
            ) : (
              <div className="p-4 text-center text-gray-400">
                No data
              </div>
            )
          }
        />

        {/* LOB/PPL/PL Table */}
        <VehiclePagecard2
          heading="Problem Area Wise Complaints"
          des={
            isValidData(
              lobPplPlTableValues
            ) ? (
              <Vehiclespares
                complaintsLobPplPlStateFilterData={
                  lobPplPlTableValues
                }
              />
            ) : (
              <div className="p-4 text-center text-gray-400">
                No data
              </div>
            )
          }
        />
      </div>

      {shouldRender && (
        <div className="max-w-[1200px] w-full flex items-stretch gap-4">

          {/* Cards Section - 35% */}
          <div className="flex flex-col gap-4 w-[35%] h-full justify-center items-center">

            {/* Open Sales Complaints */}
            <div className="h-[150px] w-[290px] mt-2 bg-white shadow-md rounded-md border flex flex-col justify-center gap-1">
              <p className="text-center text-gray-700 font-semibold">
                Open Sales Complaints (Outside TAT)
              </p>

              <p className="text-center text-gray-800 font-semibold">
                {openSalesComplaint?.doc_count || 0}
              </p>
            </div>

            {/* Reopened Sales Complaint */}
            <div className="h-[120px] w-[290px] bg-white shadow-sm rounded-md p-2 border flex flex-col gap-2">

              <p className="text-center mt-5 text-gray-700 font-semibold">
                Reopened Sales Complaint
              </p>

              <p className="text-center text-gray-800 font-semibold">
                {reOpenedSalesComplaint?.doc_count || 0}
              </p>

            </div>
          </div>

          {/* Sales Complaint TAT */}
          <SalesComplaintTat
            data={
              isYearSelected
                ? salesComplaintTatMonth
                : salesComplaintTat
            }
          />
        </div>
      )}

      {/* Detailed Table */}
      <div className="ml-4 md:ml-0 w-96 md:w-full justify-center justify-items-center">
        <JCcardtable
          heading="Detailed Complaints"
          des={<Tabledetails />}
        />
      </div>

      <NavButtons />

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-5px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
      `}</style>
    </div>
  );
};

export default Complaintindex;
